// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c41fe5df","703":"2474ec3e","787":"c74ebbaa"}[chunkId] + ".chunk.js";
};